import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Label, Modal, ModalBody, ModalHeader, Row, TabContent, TabPane } from "reactstrap";
import { toast } from "react-toastify";
toast.configure();
import "react-toastify/dist/ReactToastify.css";
import { geocodeByPlaceId } from "react-google-places-autocomplete";
import { AddressModel } from "models/City";
import { environment } from "environment/environment";
import { AdminService } from "services/AdminService";
import { Driver } from "models/Driver";
import CustomGooglePlacesAutocomplete from "components/Common/auto-complete";
import { AddressType } from "enum/AddressType";
import { Radio, RadioChangeEvent, Select } from "antd";
import { MobileDeviceType } from "enum/MobileDeviceType";
import { VehicleType } from "enum/VehicleType";
import { UpdateDriverSchema } from "schemas/updateDriverschema";
import Switch from "react-switch";
import { VerifiedStatus } from "enum/VerifyRole";
import Swal from "sweetalert2";
import { User } from "models/User";


export interface AddressProps {
  isOpen: boolean;
  handlePopup: () => void;
  driverId: string;
}

const UpdateDriver: React.FC<AddressProps> = ({ isOpen, handlePopup, driverId }: AddressProps) => {
  const [driver, setDriver] = useState({} as Driver);
  const [address, setAddress] = useState<AddressModel>();
  const [editAddress, setEditAddress] = useState(false);

  const [newPassword, setNewPassword] = useState<string>("");
  const [confirmPassword, setConfirmPassword] = useState<string>("");
  const [passwordErr, setPasswordErr] = useState<string>();
  const [confirmErr, setConfirmErr] = useState<string>();
  const [isActiveAccountStatus, setIsActiveAccountStatus] = useState<VerifiedStatus | undefined>(() => driver?.verifiedStatus);
  const [isUpdatingStatus, setIsUpdatingStatus] = useState(false);
  const [isUserNameLocked, setIsUserNameLocked] = useState(false);

  const mapprops: any = {
    componentRestrictions: { country: "ca" },
    locationRestriction: {
      north: 56.85, // Northeast corner latitude (Keep this as is)
      south: 41.6, // Southwest corner latitude (Keep this as is)
      east: -74.0, // Adjusted Northeast corner longitude to cover Kingston and Cornwall
      west: -95.15, // Keep this as is to cover the entire Ontario province
    },
  };
  useEffect(() => {
    setNewPassword("");
    setConfirmPassword("");
    setConfirmErr("");
    setPasswordErr("");
    AdminService.getDriverById(driverId).then(res => {
      if (res.success) {
        setDriver(res.data);
        setAddress(res.data.address);
        setFieldValue("firstName", res.data.firstName);
        setFieldValue("lastName", res.data.lastName);
        setFieldValue("email", res.data.email);
        setFieldValue("typeOfPhone", res.data.typeOfPhone);
        setFieldValue("phoneNumber", res.data.phoneNumber);
        setFieldValue("percentage", res.data.percentage);
        setFieldValue("vehicleType", res.data.vehicleType);
        setFieldValue("mobileDeviceType", res.data.mobileDeviceType);
        setFieldValue("userName", res.data.userName || "");

        setIsUserNameLocked(!!res.data.userName);

        // SET VEHICLE DETAILS
        setFieldValue("vehicleBrand", res.data.vehicle?.brand || "");
        setFieldValue("vehicleModel", res.data.vehicle?.model || "");
        setFieldValue("vehicleYear", res.data.vehicle?.year || "");
        setFieldValue("vehiclePrice", res.data.vehicle?.price || "");
        setFieldValue("vehicleLicense", res.data.vehicle?.license || "");
      }
    });
    setEditAddress(false);
  }, [isOpen]);

  const toggleAddressInput = () => {
    setEditAddress(!editAddress);
  };
  useEffect(() => {
    if (driver) {
      console.log('Customer data loaded. verifiedStatus:', driver.verifiedStatus);
      setIsActiveAccountStatus(
        driver.verifiedStatus === "verified"
          ? VerifiedStatus.VERIFIED
          : VerifiedStatus.DEACTIVE
      );
    }
  }, [driver]);

  const initialValues = {
    firstName: "",
    lastName: "",
    email: "",
    typeOfPhone: "",
    phoneNumber: "",
    percentage: "",
    vehicleType: "",
    mobileDeviceType: "",
    // NEW VEHICLE FIELDS
    vehicleBrand: "",
    vehicleModel: "",
    vehicleYear: "",
    vehiclePrice: "",
    vehicleLicense: "",
    userName: "",
  };

  const onSubmit = async (values: typeof initialValues, actions: any) => {
    const submitData: Driver = {
      _id: driver._id,
      firstName: values.firstName,
      lastName: values.lastName,
      email: values.email,
      typeOfPhone: values.typeOfPhone,
      phoneNumber: values.phoneNumber,
      address: address,
      percentage: values.percentage,
      vehicleType: values.vehicleType,
      mobileDeviceType: values.mobileDeviceType,
      // ADD VEHICLE OBJECT
      vehicle: {
        vehicle: values.vehicleType,
        brand: values.vehicleBrand,
        model: values.vehicleModel,
        year: values.vehicleYear,
        price: parseFloat(values.vehiclePrice) || 0,
        license: values.vehicleLicense
      },
      userName: values.userName,
    };
    if (address?.city == "" || address?.city == undefined) {
      toast.error("Address is required", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "foo-bar",
        style: { marginBottom: "4rem" },
      });
    } else {
      await AdminService.updateDriver(submitData)
        .then(res => {
          if (res.success) {
            setAddress({});
            setEditAddress(true);
            handlePopup();
            actions.resetForm();
            toast.success("Successfully Update Driver.", {
              position: toast.POSITION.BOTTOM_RIGHT,
              className: "foo-bar",
              style: { marginBottom: "4rem" },
            });
          } else {
            toast.error(res.error, {
              position: toast.POSITION.BOTTOM_RIGHT,
              className: "foo-bar",
              style: { marginBottom: "4rem" },
            });
          }
        });
    }
  };
  const handleUpdateStatus = async () => {
    if (isUpdatingStatus) return;

    const message =
      isActiveAccountStatus === VerifiedStatus.VERIFIED
        ? "Do you want to deactivate this account?"
        : "Do you want to activate this account?";

    Swal.fire({
      title: message,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#F75D21",
      cancelButtonColor: "#A9A9A9",
      confirmButtonText:
        isActiveAccountStatus === VerifiedStatus.VERIFIED
          ? "Yes, deactivate it!"
          : "Yes, activate it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsUpdatingStatus(true);
        const newStatus =
          isActiveAccountStatus === VerifiedStatus.VERIFIED
            ? VerifiedStatus.DEACTIVE
            : VerifiedStatus.VERIFIED;

        try {
          const driverData: User = {
            _id: driver?._id,
            verifiedStatus: newStatus,
          };

          const res = await AdminService.updateDriverActiveDeactive(driverData);

          if (res.success) {
            toast.success(
              `Driver account ${newStatus === VerifiedStatus.VERIFIED
                ? "activated"
                : "deactivated"
              } successfully.`,
              { position: toast.POSITION.BOTTOM_RIGHT }
            );
            setIsActiveAccountStatus(newStatus);
          } else {
            toast.error(res.message || "Failed to update status", {
              position: toast.POSITION.BOTTOM_RIGHT,
            });
          }
        } catch (error) {
          toast.error("Something went wrong", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          console.error(error);
        } finally {
          setIsUpdatingStatus(false);
        }
      }
    });
  };

  const handlePassword = (event: any) => {
    const name = event.target.name;
    const value = event.target.value;

    switch (name) {
      case "newPassword":
        if (value == "" || value == null || value == undefined) {
          setPasswordErr("Required");
        } else if (value.length < 6) {
          setPasswordErr("Password should be atleast 6 characters long.");
        } else if (!/\d/.test(value)) {
          setPasswordErr("Password must contain a number.");
        } else {
          setPasswordErr(undefined);
        }
        setNewPassword(value);
        break;
      case "confirmPassword":
        if (value == "" || value == null || value == undefined) {
          setConfirmErr("Required");
        } else if (newPassword !== value) {
          setConfirmErr("Password should match.");
        } else {
          setConfirmErr(undefined);
        }
        setConfirmPassword(value);
        break;
      default:
        break;
    }
  };

  const updatePassword = () => {
    const driverData: Driver = {
      _id: driver._id,
      password: newPassword,
    };

    if (passwordErr || confirmErr || !newPassword) return;

    AdminService.updateDriverPassword(driverData)
      .then(res => {
        if (res.success) {
          setNewPassword("");
          setConfirmPassword("");
          toast.success("Successfully updated Driver Password.", {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: "foo-bar",
            style: { marginBottom: "4rem" },
          });
          handlePopup();
        } else {
          toast.error("error occured", {
            position: toast.POSITION.BOTTOM_RIGHT,
            className: "foo-bar",
            style: { marginBottom: "4rem" },
          });
        }
      })
      .catch(error => {
        console.error(error);
      });
  };

  const handleRadioChange = (event: RadioChangeEvent) => {
    const selectedValue = event.target.value;
    setFieldValue("vehicleType", selectedValue);
  };

  const handleRadioChangeDevice = (event: RadioChangeEvent) => {
    const selectedValue = event.target.value;
    setFieldValue("mobileDeviceType", selectedValue);
  };

  const handleAddress = async (label: string, place_id: string, type: string) => {
    if (place_id !== "") {
      const address = label;
      await geocodeByPlaceId(place_id)
        .then(([place]: google.maps.GeocoderResult[]) => {
          const { long_name: postalCode = "" } = place.address_components.find(c => c.types.includes("postal_code")) || {};
          const latLng = {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng(),
          };
          setAddress({ city: address, lat: latLng.lat, lng: latLng.lng, postalCode: postalCode });
        })
        .catch(err => {
          console.log(err);
        });
    }
  };
  const { values, errors, touched, isSubmitting, handleBlur, handleChange, setFieldValue, handleSubmit } = useFormik({
    initialValues: {
      firstName: "",
      lastName: "",
      email: "",
      typeOfPhone: "Mobile",
      phoneNumber: "",
      percentage: "",
      vehicleType: "",
      mobileDeviceType: "",
      // NEW VEHICLE FIELDS
      vehicleBrand: "",
      vehicleModel: "",
      vehicleYear: "",
      vehiclePrice: "",
      vehicleLicense: "",
      userName: "",
    },
    validationSchema: UpdateDriverSchema,
    onSubmit, // Fix the attribute name here
  });

  return (
    <React.Fragment>
      <Modal isOpen={isOpen} toggle={handlePopup} size="xl">
        <ModalHeader toggle={handlePopup}>Update Driver</ModalHeader>
        <ModalBody>
          <form onSubmit={handleSubmit} autoComplete="off">
            <Card>
              <CardBody>
                <div className="tab-content">
                  <TabContent className="body mt-3">
                    <TabPane>
                      <Row>
                        <Col lg="6">
                          <div className="mb-3 form-group">
                            <Label for="basicpill-phoneno-input3" className="place-order-title">
                              First Name <Label className="title-star">*</Label>
                            </Label>
                            <input
                              value={values?.firstName}
                              onChange={handleChange}
                              id="firstName"
                              type="text"
                              placeholder=""
                              onBlur={handleBlur}
                              className={errors.firstName && touched.firstName ? "input-error form-control" : "form-control"}
                            />
                            {errors.firstName && touched.firstName && <p className="error place-order-title">{errors.firstName}</p>}
                          </div>
                        </Col>
                        <Col lg="6">
                          <div className="mb-3 form-group">
                            <Label for="basicpill-email-input4" className="place-order-title">
                              Last Name <Label className="title-star">*</Label>
                            </Label>
                            <input
                              value={values.lastName}
                              onChange={handleChange}
                              id="lastName"
                              type="text"
                              placeholder=""
                              onBlur={handleBlur}
                              className={errors.lastName && touched.lastName ? "input-error form-control" : "form-control"}
                            />
                            {errors.lastName && touched.lastName && <p className="error place-order-title">{errors.lastName}</p>}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="6">
                          {editAddress ? (
                            <div className="mb-3 form-group">
                              <div className="d-flex flex-wrap align-items-center">
                                <Label for="basicpill-firstname-input1 input-title" className="place-order-title">
                                  Address <Label className="title-star">*</Label>
                                </Label>
                                <div className="label-wrap" onClick={toggleAddressInput}>
                                  <span className="custom-label">{"cancel"}</span>
                                </div>
                              </div>
                              <div>
                                <CustomGooglePlacesAutocomplete
                                  apiKey={environment.google_maps_key}
                                  autocompletionRequest={mapprops}
                                  addressType={AddressType.pickup}
                                  selectProps={{
                                    name: "address",
                                  }}
                                  handleAddress={handleAddress}
                                />
                              </div>
                            </div>
                          ) : (
                            <>
                              <div className="mb-3 form-group">
                                <div className="d-flex flex-wrap align-items-center">
                                  <Label for="basicpill-firstname-input1 input-title" className="place-order-title">
                                    Address <Label className="title-star">*</Label>
                                  </Label>
                                  <div className="label-wrap" onClick={toggleAddressInput}>
                                    <span className="font-size-12 px-2 fw-medium">{"Edit address"}</span>
                                  </div>
                                </div>
                              </div>
                              <input
                                value={address?.city}
                                type="text"
                                disabled={true}
                                placeholder=""
                                className="form-control adress-input"
                              />
                              {address?.city === undefined ||
                                address?.city === "" ||
                                (address?.city === null && <p className="text-danger">You have to select a address.</p>)}
                            </>
                          )}
                        </Col>

                        <Col lg="6">
                          <div className="mb-3 form-group">
                            <Label for="basicpill-email-input4" className="place-order-title">
                              Email <Label className="title-star">*</Label>
                            </Label>
                            <input
                              value={values.email}
                              onChange={handleChange}
                              id="email"
                              type="text"
                              placeholder=""
                              onBlur={handleBlur}
                              className={errors.email && touched.email ? "input-error form-control" : "form-control"}
                            />
                            {errors.email && touched.email && <p className="error place-order-title">{errors.email}</p>}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="6">
                          <div className="mb-3 form-group">
                            <Label for="basicpill-phoneno-input3" className="place-order-title">
                              Phone Number <Label className="title-star">*</Label>
                            </Label>
                            <input
                              value={values.phoneNumber}
                              onChange={handleChange}
                              id="phoneNumber"
                              type="text"
                              placeholder=""
                              onBlur={handleBlur}
                              className={errors.phoneNumber && touched.phoneNumber ? "input-error form-control" : "form-control"}
                            />
                            {errors.phoneNumber && touched.phoneNumber && <p className="error place-order-title">{errors.phoneNumber}</p>}
                          </div>
                        </Col>
                        <Col lg="6">
                          <div className="mb-3 form-group">
                            <Label for="basicpill-email-input4" className="place-order-title">
                              Percentage <Label className="title-star">*</Label>
                            </Label>
                            <input
                              value={values.percentage}
                              onChange={handleChange}
                              id="percentage"
                              type="number"
                              placeholder=""
                              onBlur={handleBlur}
                              className={errors.percentage && touched.percentage ? "input-error form-control" : "form-control"}
                            />
                            {errors.percentage && touched.percentage && <p className="error place-order-title">{errors.percentage}</p>}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="6">
                          <div className="mb-3 form-group">
                            <Label for="basicpill-declaration-input10" className="place-order-title">
                              Mobile Device Type<Label className="title-star">*</Label>
                            </Label>
                            <div className="col-lg-6 form-check">
                              <Radio.Group value={values.mobileDeviceType} onChange={handleRadioChangeDevice} onBlur={handleBlur}>
                                <Radio value={MobileDeviceType.iOS}>iOS</Radio>
                                <Radio value={MobileDeviceType.Android}>Android</Radio>
                              </Radio.Group>
                            </div>
                            {errors.mobileDeviceType && touched.mobileDeviceType && (
                              <p className="error place-order-title">{errors.mobileDeviceType}</p>
                            )}
                          </div>
                        </Col>
                        <Col lg="6">
                          <div className="mb-3 form-group">
                            <Label for="basicpill-declaration-input10" className="place-order-title">
                              Type Of Vehicle<Label className="title-star">*</Label>
                            </Label>
                            <div className="col-lg-6 form-check">
                              <Radio.Group value={values.vehicleType} onChange={handleRadioChange} onBlur={handleBlur}>
                                <Radio value={VehicleType.CAR}>Car</Radio>
                                <Radio value={VehicleType.SUV}>SUV</Radio>
                                <Radio value={VehicleType.VAN}>Mini Van</Radio>
                              </Radio.Group>
                            </div>
                            {errors.vehicleType && touched.vehicleType && (
                              <p className="error place-order-title">{errors.vehicleType}</p>
                            )}
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="6">
                          <div className="mb-3 form-group">
                            <Label for="vehicleBrand" className="place-order-title">
                              Vehicle Brand
                            </Label>
                            <input
                              value={values.vehicleBrand}
                              onChange={handleChange}
                              id="vehicleBrand"
                              type="text"
                              placeholder=""
                              onBlur={handleBlur}
                              className="form-control"
                            />
                          </div>
                        </Col>
                        <Col lg="6">
                          <div className="mb-3 form-group">
                            <Label for="vehicleModel" className="place-order-title">
                              Vehicle Model
                            </Label>
                            <input
                              value={values.vehicleModel}
                              onChange={handleChange}
                              id="vehicleModel"
                              type="text"
                              placeholder=""
                              onBlur={handleBlur}
                              className="form-control"
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="6">
                          <div className="mb-3 form-group">
                            <Label for="vehicleYear" className="place-order-title">
                              Vehicle Year
                            </Label>
                            <input
                              value={values.vehicleYear}
                              onChange={handleChange}
                              id="vehicleYear"
                              type="text"
                              placeholder=""
                              onBlur={handleBlur}
                              maxLength={4}
                              className="form-control"
                            />
                            {errors.vehicleYear && touched.vehicleYear && <p className="error place-order-title">{errors.vehicleYear}</p>}
                          </div>
                        </Col>
                        <Col lg="6">
                          <div className="mb-3 form-group">
                            <Label for="vehicleLicense" className="place-order-title">
                              Vehicle License Plate (Optional)
                            </Label>
                            <input
                              value={values.vehicleLicense}
                              onChange={handleChange}
                              id="vehicleLicense"
                              type="text"
                              placeholder=""
                              onBlur={handleBlur}
                              className="form-control"
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="6">
                          <div className="mb-3 form-group">
                            <Label for="basicpill-phoneno-input3" className="place-order-title">
                              User Name <Label className="title-star">*</Label>
                            </Label>
                            <input
                              type="text"
                              id="userName"
                              value={values.userName}
                              disabled={isUserNameLocked}
                              placeholder=""
                              onChange={handleChange}
                              onBlur={handleBlur}
                              className={errors.userName && touched.userName ? "input-error form-control" : "form-control"}
                            />
                            {errors.userName && touched.userName && <p className="error place-order-title">{errors.userName}</p>}
                          </div>
                        </Col>
                      </Row>
                      <div className="clearfix">
                        <div className="d-lg-flex d-md-flex justify-content-lg-end justify-content-md-end">
                          <button disabled={isSubmitting} type="submit" className="btn btn-primary btn-sm px-5 me-lg-2 me-md-2 mb-2 ms-1">
                            Update
                          </button>
                        </div>
                      </div>
                    </TabPane>
                  </TabContent>
                </div>
              </CardBody>
            </Card>
          </form>
          <Card>
            <CardBody className="mx-lg-6">
              <h6>Change Password</h6>
              <Row>
                <Col lg="5">
                  <div className="mb-3 form-group">
                    <Label>New Password</Label>
                    <input
                      type="password"
                      name="newPassword"
                      value={newPassword}
                      onChange={handlePassword}
                      autoComplete="new-password"
                      className={passwordErr ? "input-error form-control" : "form-control"}
                    />
                    {passwordErr && <p className="error col-lg-12">{passwordErr}</p>}
                  </div>
                </Col>
                <Col lg="5">
                  <div className="mb-3 form-group">
                    <Label>Confirm Password</Label>
                    <input
                      type="password"
                      name="confirmPassword"
                      value={confirmPassword}
                      onChange={handlePassword}
                      className={confirmErr ? "input-error form-control" : "form-control"}
                    />
                    {confirmErr && <p className="error col-lg-12">{confirmErr}</p>}
                  </div>
                </Col>
                <Col lg="2">
                  <div className="mt-lg-4">
                    <button className="btn btn-primary btn-sm px-3 mt-lg-3 w-100" onClick={updatePassword}>
                      Save
                    </button>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>

          <Card>
            <CardBody className="mx-lg-5">
              {/* <h6>Activate / Deactivate Account</h6> */}
              <Row className="d-flex justify-content-between align-items-center">
                <Col lg="12">
                  <div className="mb-3 d-flex justify-content-between align-items-center" style={{ width: "100%" }}>
                    <Label className="me-3">
                      <h6>Activate / Deactivate Account</h6>

                      {/* This account is {isActiveAccountStatus === VerifiedStatus.VERIFIED ? "active one you can deactivate it" : "deactive one you can activate it"} */}
                    </Label>

                    <Col lg="3">
                      <button
                        className={`btn btn-sm px-3 w-100 ${isActiveAccountStatus === VerifiedStatus.VERIFIED ? "btn-primary" : "btn-primary"
                          }`}
                        onClick={handleUpdateStatus}
                        disabled={isUpdatingStatus}
                      >
                        {isActiveAccountStatus === VerifiedStatus.VERIFIED ? "Deactivate" : "Activate"}
                        {isUpdatingStatus && <span className="spinner-border spinner-border-sm ms-2"></span>}
                      </button>
                    </Col>
                  </div>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default UpdateDriver;
